import { IGovernmentProjectResponse, IGovernmentProjectDetailResponse } from "../../../model/base/response/government-project-response";
import { Pagination } from "../../../model/paginatiion";

export type GovernmentProjectsState = {
    governmentProjects: Pagination<IGovernmentProjectResponse>;
    projectDetail: IGovernmentProjectDetailResponse | null;
};

export enum ACTION_TYPES {
    SET_GOVERNMENT_PROJECTS = 'SET_GOVERNMENT_PROJECTS',
    CLEAR_GOVERNMENT_PROJECTS = 'CLEAR_GOVERNMENT_PROJECTS',
    SET_PROJECT_DETAIL = 'SET_PROJECT_DETAIL',
}

export const initialState: GovernmentProjectsState = {
    governmentProjects: new Pagination<IGovernmentProjectResponse>(),
    projectDetail: null
};

export const GovernmentProjectsReducer = (state: GovernmentProjectsState, action: any): GovernmentProjectsState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.SET_GOVERNMENT_PROJECTS:
            return {
                ...state,
                governmentProjects: payload,
            };
        case ACTION_TYPES.CLEAR_GOVERNMENT_PROJECTS:
            return {
                ...state,
                governmentProjects: new Pagination<IGovernmentProjectResponse>(),
            };
        case ACTION_TYPES.SET_PROJECT_DETAIL:
            return {
                ...state,
                projectDetail: payload,
            };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
